import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import Button from 'components/Button/Button';
import Panel from 'components/Panel/Panel';
import Toggle from 'components/Toggle/Toggle';
import { SHOW_ARCHIVED } from 'constants/formFields';
import { BUTTON_VARIANT } from 'constants/interfaces';

import Loader from '../Loader/Loader';
import Separator from '../Separator/Separator';
import EmptyList from './components/EmptyList/EmptyList';
import UploadFile from './components/UploadFile/UploadFile';

import type { IDataSetsEmptyListView } from './interfaces/IDataSetsEmptyListView';

import styles from './scss/DataSetsEmptyList.module.scss';

function DataSetsEmptyList({
  title, subTitle, uploadControl, isUploadFileVisible, isProfitCenterEmpty, isSupplierEmpty, onDownloadExample,
  isLoading, subTitleSecondLine, onShowArchiveChange, control, titleToggle, onAddRecord,
}: IDataSetsEmptyListView) {
  const { t } = useTranslation();
  return (
    <div className={styles.root}>
      <Loader isPageLoading={isLoading} />
      <Panel className={styles.panel}>
        <div className={styles.wrapper}>
          <div className={styles.headerWrapper}>
            <div className={styles.header}>
              <div>{title}</div>
              <div className={styles.description}>{subTitle}</div>
              { subTitleSecondLine ? (<div className={styles.description}>{subTitleSecondLine}</div>) : null }

            </div>
            <div className={styles.buttonGroup}>
              <div className={styles.showArchived}>
                <Controller
                  name={SHOW_ARCHIVED}
                  control={control}
                  render={({ field: { onChange, value, name } }) => (
                    <Toggle
                      value={name}
                      checked={!!value}
                      name={name}
                      onChange={(e) => {
                        onChange(e.target.checked);
                        onShowArchiveChange?.(e.target.checked);
                      }}
                    />
                  )}
                />
                <span>{titleToggle}</span>
              </div>
              {isUploadFileVisible ? (
                <Button
                  title={t('dataSetsManagement.addRecord')}
                  startIcon={<PlusIcon />}
                  variant={BUTTON_VARIANT.primary}
                  onClick={onAddRecord}
                />
              ) : null}
            </div>
          </div>
          <Separator className={styles.separator} />
          {isUploadFileVisible
            ? <UploadFile uploadControl={uploadControl} onDownloadExample={onDownloadExample} />
            : (
              <EmptyList
                title={title}
                isProfitCenterEmpty={isProfitCenterEmpty}
                isSupplierEmpty={isSupplierEmpty}
              />
            )}
        </div>
      </Panel>
    </div>
  );
}

export default DataSetsEmptyList;
